import { useParams } from "react-router-dom";
import { Header } from "./components/Header";
import { PlatformEnum } from "../../shared/utils";
import {
  captablePlatformData,
  esopPlatformData,
  PlatformDataType,
} from "./components/data";
import { PageData } from "./components/PageData";
import { useEffect, useState } from "react";
import Loader from "../../utils/loader";

export function ExplorePage() {
  const platform = useParams().platform as PlatformEnum;

  const [data, setData] = useState<PlatformDataType>();
  const s3Url =
    platform === PlatformEnum.investor
      ? "https://equion-dev.s3.us-west-2.amazonaws.com/demoPages/demo-portfolio.json"
      : `https://equion-dev.s3.us-west-2.amazonaws.com/demoPages/demo-${platform}.json`;

  const fetchData = async () => {
    try {
      const response = await fetch(s3Url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();
      setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [s3Url]);

  return data ? (
    <>
      <div className="mt-6">
        <Header
          platform={platform}
          heading={data.headerData.heading}
          characteristics={data.headerData.characteristics}
          icons={data.headerData.icons}
        />
        <div>
          {data.pageData.map((section, index) => {
            return (
              <PageData
                key={section.header}
                header={section.header}
                subheader={section.subheader}
                bulletPoints={section.bulletPoints}
                imagePath={section.imagePath}
                imageFirst={index % 2 !== 0}
                bgColor={section.bgColor}
              />
            );
          })}
        </div>
      </div>
    </>
  ) : (
    <div className="h-[800px] bg-white">
      <div className="flex flex-col h-[200px] items-center justify-center bg-gradient-to-t from-blue-950 to-blue-500 p-5 rounded-t-lg text-white">
        <h2 className="col-span-2 h-2 rounded bg-gray-200 mb-4"></h2>
          <div className="bg-white text-black px-4 py-4 rounded-md text-sm text-center w-full h-[100px] md:h-[50px] flex items-center justify-center gap-4 md:mb-4">
            <div className="w-full h-2 rounded bg-gray-200 animate-pulse"></div>
          </div>
      
      </div>
      <Loader />
    </div>
  );
}
